import { Component, inject, input, signal } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { IconComponent } from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-badge-copy',
  imports: [IconComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div
        class="flex gap-x-1 bg-gray-100 p-1 rounded max-w-max text-[10px] transition-all duration-300"
        [class]="disabled() ? 'text-neutral-6' : 'cursor-pointer hover:bg-gray-200'"
        (click)="copy()"
      >
        @if (!copied()) {
          {{ id() }}
          <ui-icon icon="copy" />
        } @else {
          {{ t('DISTRIBUTION_NETWORK.TABLE.COPY_LABEL') }}
          <ui-icon icon="check" class="text-green" />
        }
      </div>
    </ng-container>
  `,
})
export class BadgeCopyComponent {
  private readonly clipboard = inject(Clipboard);

  disabled = input<boolean>();
  id = input.required<string>();

  copied = signal<boolean>(false);

  private resetTimer: ReturnType<typeof setTimeout> | null = null;

  copy() {
    if (this.disabled()) return;

    this.clipboard.copy(this.id()!);
    this.copied.set(true);

    // Clear any existing timer to avoid overlapping
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
    }

    // Set a timer to reset the copied state after 3 seconds
    this.resetTimer = setTimeout(() => {
      this.copied.set(false);
    }, 1000);
  }
}
